import { ADMIN_LOGIN_FAIL, ADMIN_LOGIN_SUCCESS } from '../actions/actionType';

const initialState = {
  isAuthenticated: false,
  isAlreadyLoggined: false,
  user: null,
  error: null,
  loading: false,
};

const _AdminAuth = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_LOGIN_SUCCESS:
      return { loading: false, isAuthenticated: true, user: action.payload };
    case ADMIN_LOGIN_FAIL:
      return { loading: false, isAuthenticated: false, error: action.payload };
    default:
      return state;
  }
};

export { _AdminAuth };
